import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMount } from 'react-use';

import {
  Content,
  Divider,
  HStack,
  Header,
  PageTitle,
  SidebarTrigger,
  VStack,
} from '@eluve/components';
import {
  DynamicArtifactTemplateBuilder,
  templateBuilderStore,
} from '@eluve/smart-blocks';

import { DynamicArtifactTemplatePreview } from './components/DynamicArtifactPreview';
import { PrefillTemplateSection } from './components/PrefillTemplateSection';
import { TemplateEditingPageHeaderButtons } from './components/TemplateEditingPageHeaderButtons';
import { useCreateTemplate } from './useCreateTemplate';
import { useIsOrganizationRoute } from './useIsOrganizationRoute';

export const CreateOutputTemplatePage: React.FC = () => {
  const [isValid, setIsValid] = useState(false);
  const navigate = useNavigate();
  const isOrganizationRoute = useIsOrganizationRoute();

  const { handleSaveDraftTemplate, handleSubmitTemplate } = useCreateTemplate();

  useMount(() => {
    templateBuilderStore.send({ type: 'reset' });
  });

  return (
    <>
      <Header>
        {isOrganizationRoute && <SidebarTrigger />}
        <PageTitle isFullWidth>Create Template</PageTitle>

        <TemplateEditingPageHeaderButtons
          handleSaveDraft={handleSaveDraftTemplate}
          handleSubmit={handleSubmitTemplate}
          handleDeleteDraft={() => navigate('..')}
          saveDraftDisabled={!isValid}
          submitDisabled={!isValid}
        />
      </Header>

      <Content>
        <HStack align="stretch" className="h-full divide-x">
          <VStack className="h-full min-w-0 flex-1 overflow-y-auto p-6" gap={6}>
            <PrefillTemplateSection />
            <Divider className="my-0" />
            <DynamicArtifactTemplateBuilder
              onIsValidChange={setIsValid}
              showJsonSchema
            />
          </VStack>
          <VStack className="h-full min-w-0 flex-1 overflow-y-auto bg-bg-tertiary p-6">
            <DynamicArtifactTemplatePreview />
          </VStack>
        </HStack>
      </Content>
    </>
  );
};
